import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import timelinePlugin from "@fullcalendar/timeline";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { format, parseISO } from "date-fns";

const TrainingCalenderfol = ({
  initialDate = new Date(),
  resourceData = [],
  eventData = [],
  fetchResources,
  fetchEvents,
  aspectRatio = 1.8,
  resourceAreaWidth = "15%",
  showHeader = true,
  onDatesChange,
}) => {    
  const calendarRef = useRef(null);
  const [resources, setResources] = useState(resourceData);
  const [events, setEvents] = useState(eventData);
  const [currentView, setCurrentView] = useState(null);

  useEffect(() => {
    if (!fetchResources && !fetchEvents) return;

    const view = calendarRef.current?.getApi().view;
    if (!view) return;

    setCurrentView(view);

    const loadData = async () => {
      try {
        if (fetchResources) {
          const resourceResponse = await fetchResources({
            start: view.startStr,
            end: view.endStr,
            timezone: view.option("timezone"),
            DSType: "trainers",
          });
          setResources(resourceResponse);
        }

        if (fetchEvents) {
          const eventResponse = await fetchEvents({
            start: view.startStr,
            end: view.endStr,
            timezone: view.option("timezone"),
            DSType: "trainings",
          });
          setEvents(eventResponse);
        }
      } catch (error) {
        console.error("Error loading calendar data:", error);
      }
    };

    loadData();
  }, [fetchResources, fetchEvents]);

 const handleDatesSet = (arg) => {
    setCurrentView(arg.view);
    logCurrentWeekDates(arg.view);
    // Call the callback with the dates
    if (onDatesChange) {
      onDatesChange({
        start: arg.view.currentStart,
        end: arg.view.currentEnd
      });
    }
  };
  const handlePrevClick = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.prev();
    logCurrentWeekDates(calendarApi.view);
  };

  const handleNextClick = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.next();
    logCurrentWeekDates(calendarApi.view);
  };

  const logCurrentWeekDates = (view) => {
    if (!view) return;
    
    const startDate = view.currentStart;
    const endDate = view.currentEnd;
    console.log('startDate',startDate);
    console.log('endDate',endDate);
    
  };

  function CleanTitle(title) {
    if (!title) return "";

    const txt = document.createElement("textarea");
    txt.innerHTML = title;
    const decoded = txt.value;

    const parts = decoded.split(":");
    return parts.length > 1 ? parts.slice(1).join(":").trim() : decoded.trim();
  }

  function TimeRange(start, end) {
    if (!start || !end) return null;

    const options = { hour: "numeric", hour12: true };

    const startTime = new Date(start)
      .toLocaleTimeString("en-US", options)
      .toLowerCase()
      .replace(":00", "");
    const endTime = new Date(end)
      .toLocaleTimeString("en-US", options)
      .toLowerCase()
      .replace(":00", "");

    return (
      <>
        <i className="bi bi-clock" style={{ marginRight: 4 }}></i>
        {startTime} - {endTime}
      </>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12 calndar-bg-outer">
        <style>
          {`
          .trainer-header {
            background-color: #27568B !important;
            color: white !important;
            font-weight: bold;
            padding: 8px;
          }
          .trainer-cell {
            background-color: #fff !important;
            color: #000 !important;
            font-weight: bold !important;
          }
          .fc-timeline-header-row {
            background-color: #27568B !important;
            font-weight: bold;
          }
          .fc-timeline-slot-frame, a {
            color: white !important;
            text-decoration: none !important;
          }
          .fc .fc-toolbar {
            padding-top: 5px !important;
            padding-bottom: 10px !important;
            margin-bottom: 0px !important;
          }
        //   .fc-toolbar-chunk {
        //     display: flex;
        //     justify-content: flex-end;
        //     width: 100%;
        //   }
          .fc-prev-button, .fc-next-button {
            background-color: #27568B !important;
            border: none !important;
            color: white !important;
            padding: 6px 12px !important;
            margin-left: 8px !important;
          }
          .fc-prev-button:hover, .fc-next-button:hover {
            background-color: #1d4775 !important;
          }
          .fc-toolbar-title {
            margin-right: auto;
          }
        `}
        </style>
        <div id="calendar" className="bdr-cal">
          <FullCalendar
            ref={calendarRef}
            schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
            plugins={[timelinePlugin, resourceTimelinePlugin]}
            initialDate={initialDate}
            now={new Date()}
            editable={false}
            aspectRatio={aspectRatio}
            scrollTime="00:00"
            headerToolbar={{
              left: showHeader ? "title" : "",
              center: showHeader ? "" : "",
              right: showHeader ? "prev,next" : "",
            }}
            customButtons={{
              prev: {
                click: handlePrevClick,
              },
              next: {
                click: handleNextClick,
              },
            }}
            initialView="resourceTimelineWeek"
            views={{
              resourceTimelineWeek: {
                type: "resourceTimeline",
                duration: { weeks: 1 },
                slotDuration: { days: 1 },
                slotLabelFormat: [
                  { day: "numeric", month: "short", weekday: "short" },
                ],
              },
            }}
            resourceAreaWidth={resourceAreaWidth}
            resourceAreaHeaderClassNames="trainer-header"
            resourceAreaHeaderContent="Trainers"
            resourceLabelClassNames="trainer-cell"
            resourceColumns={[
              {
                field: "title",
                headerContent: "Trainer",
              },
            ]}
            resources={resources}
            events={events}
            datesSet={handleDatesSet}
            eventContent={(eventInfo) => (
              <div
                style={{
                  height: "100%",
                  padding: "4px 6px",
                  borderRadius: "6px",
                  background: "#ffffff",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "#4a6cf7",
                    marginBottom: "2px",
                  }}
                >
                  {TimeRange(eventInfo?.event?.start, eventInfo?.event?.end)}
                </div>
                <div
                  style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    color: "#333",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {CleanTitle(eventInfo?.event?.title)}
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default TrainingCalenderfol;